import ChatsDb   from "@/firebase/chat-db";
import DemandsDb from "@/firebase/demands-db";
import axios     from "axios";

export default {
    createDemand            : async ({rootState, commit}, {demandId, message}) => {
        const user   = {...rootState.authentication.user};
        const chatDb = new ChatsDb(demandId);

        message.author = user;

        const initialMessage = await chatDb.create(message);

        commit("appendMessage", initialMessage);
    },
    addChatMessage          : async ({rootState}, payload) => {
        const user     = {...rootState.authentication.user};
        const demandDb = new DemandsDb();
        const chatDb   = new ChatsDb(payload.demandId);

        const messageObject = {
            type   : "simple",
            author : user,
            message: payload.message
        };

        const createdMessage = await chatDb.create(
            messageObject
        );

        if (user.id === payload.demandAuthorId) {
            await demandDb.updateAuthorLastInteractionTimestamp(payload.demandId);
        } else {
            const demand     = await demandDb.read(payload.demandId);
            const minutesAgo = (Math.floor(Date.now() / 1000) - demand.authorLastInteraction) / 60;

            if (minutesAgo >= 3) {
                await axios.post(
                    "https://us-central1-rr-production-cbc1f.cloudfunctions.net/notifySingleUserForNewMessages",
                    {
                        "demand": demand.id,
                        "author": demand.author.id
                    }
                );
            }
        }

        return createdMessage;
    },
    authorViewedChatMessages: async (state, payload) => {
        const demandDb = new DemandsDb();

        await demandDb.updateAuthorLastInteractionTimestamp(payload.demandId);
    },
    deleteMessage           : async (store, {demandID, messageID}) => {
        const chatDb = new ChatsDb(demandID);

        try {
            const response = await chatDb.delete(messageID);
            response.delete();

            return response;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }

        return false;
    }
};
